import { useMutation } from '@tanstack/react-query';

import { MutationConfig, mutationFn } from '@/lib/react-query';
import { apiRoutes } from '@/utils/routes';

interface IHelpdeskTicket {
  name: string;
  partnerName: string;
  ticketTypeId: number;
  xContractNumber: number;
}

const createHelpdeskTicketFn = (data: IHelpdeskTicket): Promise<number[]> => {
  return mutationFn(apiRoutes.createHelpdeskTicket, data);
};

export const useCreateHelpdeskTicket = ({ ...configs }: MutationConfig<typeof createHelpdeskTicketFn> = {}) =>
  useMutation({
    mutationFn: createHelpdeskTicketFn,
    ...configs,
  });
